module.exports = __webpack_public_path__ + "img/LATAM_FRUIT.459152fb.png";